import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginComponent } from './login.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
  imports: [
    IonicModule, 
    CommonModule, 
    FormsModule,
    SharedModule,
    ReactiveFormsModule
  ],
  exports: [],
  declarations: [LoginComponent],
  providers: [],
})
export class LoginModule { }
